import { render, staticRenderFns } from "./LikeCompetitionComponent.vue?vue&type=template&id=03e663fe&scoped=true&"
import script from "./LikeCompetitionComponent.vue?vue&type=script&lang=js&"
export * from "./LikeCompetitionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e663fe",
  null
  
)

export default component.exports